import type { ReactNode } from 'react';
import { LayoutGrid, Rows3 } from 'lucide-react';
import type { ListView } from '@/store/preferencesStore';

const OPTIONS = [
  { view: 'table', label: 'Таблица', Icon: Rows3 },
  { view: 'cards', label: 'Карточки', Icon: LayoutGrid },
] as const;

/** Table or cards, for a list that can be shown both ways. */
export function ViewSwitch({ value, onChange }: { readonly value: ListView; readonly onChange: (view: ListView) => void }): ReactNode {
  return (
    <div className="segmented" role="group" aria-label="Вид списка">
      {OPTIONS.map(({ view, label, Icon }) => (
        <button key={view} type="button" title={label} aria-label={label} aria-pressed={value === view} onClick={() => onChange(view)}>
          <Icon size={15} aria-hidden="true" />
        </button>
      ))}
    </div>
  );
}
